export const EmployeeActionTypes = {
    LOGOUT: 'LOGOUT',

    ADD_EMPLOYEE_REQUEST: 'ADD_EMPLOYEE_REQUEST',
    ADD_EMPLOYEE_REQUEST_SUCCESS: 'ADD_EMPLOYEE_REQUEST_SUCCESS',
    ADD_EMPLOYEE_REQUEST_ERROR: 'ADD_EMPLOYEE_REQUEST_ERROR',
    ADD_EMPLOYEE_REQUEST_STATUS: 'ADD_EMPLOYEE_REQUEST_STATUS',

    EMPLOYEE_LIST_REQUEST: 'EMPLOYEE_LIST_REQUEST',
    EMPLOYEE_LIST_REQUEST_SUCCESS: 'EMPLOYEE_LIST_REQUEST_SUCCESS',
    EMPLOYEE_LIST_REQUEST_ERROR: 'EMPLOYEE_LIST_REQUEST_ERROR',

    EMPLOYEE_DETAIL_REQUEST: 'EMPLOYEE_DETAIL_REQUEST',
    EMPLOYEE_DETAIL_REQUEST_SUCCESS: 'EMPLOYEE_DETAIL_REQUEST_SUCCESS',
    EMPLOYEE_DETAIL_REQUEST_ERROR: 'EMPLOYEE_DETAIL_REQUEST_ERROR',

    EMPLOYEE_UPDATE_DETAILS_REQUEST: 'EMPLOYEE_UPDATE_DETAILS_REQUEST',
    EMPLOYEE_UPDATE_DETAILS_REQUEST_SUCCESS: 'EMPLOYEE_UPDATE_DETAILS_REQUEST_SUCCESS',
    EMPLOYEE_UPDATE_DETAILS_REQUEST_ERROR: 'EMPLOYEE_UPDATE_DETAILS_REQUEST_ERROR',
    EMPLOYEE_UPDATE_DETAILS_REQUEST_STATUS: 'EMPLOYEE_UPDATE_DETAILS_REQUEST_STATUS',

    CLOCK_IN_REQUEST: 'CLOCK_IN_REQUEST',
    CLOCK_IN_REQUEST_SUCCESS: 'CLOCK_IN_REQUEST_SUCCESS',
    CLOCK_IN_REQUEST_ERROR: 'CLOCK_IN_REQUEST_ERROR',
    CLOCK_IN_REQUEST_STATUS: 'CLOCK_IN_REQUEST_STATUS',

    CLOCK_OUT_REQUEST: 'CLOCK_OUT_REQUEST',
    CLOCK_OUT_REQUEST_SUCCESS: 'CLOCK_OUT_REQUEST_SUCCESS',
    CLOCK_OUT_REQUEST_ERROR: 'CLOCK_OUT_REQUEST_ERROR',
    CLOCK_OUT_REQUEST_STATUS: 'CLOCK_OUT_REQUEST_STATUS',

    EMPLOYEE_ATTENDANCE_LIST_REQUEST: 'EMPLOYEE_ATTENDANCE_LIST_REQUEST',
    EMPLOYEE_ATTENDANCE_LIST_REQUEST_SUCCESS: 'EMPLOYEE_ATTENDANCE_LIST_REQUEST_SUCCESS',
    EMPLOYEE_ATTENDANCE_LIST_REQUEST_ERROR: 'EMPLOYEE_ATTENDANCE_LIST_REQUEST_ERROR',

    ADD_AVAILABILITY_REQUEST: 'ADD_AVAILABILITY_REQUEST',
    ADD_AVAILABILITY_REQUEST_SUCCESS: 'ADD_AVAILABILITY_REQUEST_SUCCESS',
    ADD_AVAILABILITY_REQUEST_ERROR: 'ADD_AVAILABILITY_REQUEST_ERROR',
    ADD_AVAILABILITY_REQUEST_STATUS: 'ADD_AVAILABILITY_REQUEST_STATUS',

    AVAILABILITY_LIST_REQUEST: 'AVAILABILITY_LIST_REQUEST',
    AVAILABILITY_LIST_REQUEST_SUCCESS: 'AVAILABILITY_LIST_REQUEST_SUCCESS',
    AVAILABILITY_LIST_REQUEST_ERROR: 'AVAILABILITY_LIST_REQUEST_ERROR',

    UPDATE_AVAILABILITY_REQUEST: 'UPDATE_AVAILABILITY_REQUEST',
    UPDATE_AVAILABILITY_REQUEST_SUCCESS: 'UPDATE_AVAILABILITY_REQUEST_SUCCESS',
    UPDATE_AVAILABILITY_REQUEST_ERROR: 'UPDATE_AVAILABILITY_REQUEST_ERROR',
    UPDATE_AVAILABILITY_REQUEST_STATUS: 'UPDATE_AVAILABILITY_REQUEST_STATUS',

    REMOVE_FROM_BUSINESS_REQUEST: 'REMOVE_FROM_BUSINESS_REQUEST',
    REMOVE_FROM_BUSINESS_REQUEST_SUCCESS: 'REMOVE_FROM_BUSINESS_REQUEST_SUCCESS',
    REMOVE_FROM_BUSINESS_REQUEST_ERROR: 'REMOVE_FROM_BUSINESS_REQUEST_ERROR',
    REMOVE_FROM_BUSINESS_REQUEST_STATUS: 'REMOVE_FROM_BUSINESS_REQUEST_STATUS',

    EMPLOYEE_DASHBOARD_DATA_REQUEST: 'EMPLOYEE_DASHBOARD_DATA_REQUEST',
    EMPLOYEE_DASHBOARD_DATA_REQUEST_SUCCESS: 'EMPLOYEE_DASHBOARD_DATA_REQUEST_SUCCESS',
    EMPLOYEE_DASHBOARD_DATA_REQUEST_ERROR: 'EMPLOYEE_DASHBOARD_DATA_REQUEST_ERROR',

    LOGIN_CODE_CHECK_REQUEST: 'LOGIN_CODE_CHECK_REQUEST',
    LOGIN_CODE_CHECK_REQUEST_SUCCESS: 'LOGIN_CODE_CHECK_REQUEST_SUCCESS',
    LOGIN_CODE_CHECK_REQUEST_ERROR: 'LOGIN_CODE_CHECK_REQUEST_ERROR',

    CLEAR_LOGIN_CODE_CHECK: 'CLEAR_LOGIN_CODE_CHECK',

    EMPLOYEE_ATTENDANCE_CHECK_REQUEST: 'EMPLOYEE_ATTENDANCE_CHECK_REQUEST',
    EMPLOYEE_ATTENDANCE_CHECK_REQUEST_SUCCESS: 'EMPLOYEE_ATTENDANCE_CHECK_REQUEST_SUCCESS',
    EMPLOYEE_ATTENDANCE_CHECK_REQUEST_ERROR: 'EMPLOYEE_ATTENDANCE_CHECK_REQUEST_ERROR'
}
